import React from "react";

import { Tabs, Tab } from "@mui/material";

import { useNotification } from "../../context";
import { NotificationTabKey } from "../../model";
import { NotificationTabs } from "./tabs.header";

const StatusTabs: React.FC = () => {
  const { currentTab, setTab } = useNotification();

  const handleChange = (_: React.ChangeEvent<{}>, newValue: string) => {
    setTab(newValue as NotificationTabKey);
  };

  return (
    <Tabs
      className={"Tabs-Notifications"}
      value={currentTab}
      onChange={handleChange}
      indicatorColor="primary"
      textColor="primary"
    >
      {NotificationTabs.map((tab) => (
        <Tab
          className={"Tab-Notifications-child"}
          key={tab.key}
          value={tab.key}
          label={tab.label}
          sx={{
            fontWeight: 700,
            fontSize: "1.2rem",
            mx: 1,
            p: 0.2,
            color: "#3E3D3D",
          }}
        />
      ))}
    </Tabs>
  );
};

export default StatusTabs;
